import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransferenciasService } from '../../../services/transferencias.service';
import { Transferencias } from './../../../models/transferencias';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as numeral from 'numeral';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-transferencias-list-modal',
  templateUrl: './transferencias-list-modal.component.html',
  styleUrls: ['./transferencias-list-modal.component.css'],
  providers: [ TransferenciasService ]
})
export class TransferenciasListModalComponent implements OnInit {
  @Output() onSelectedRow = new EventEmitter();
	@Input() qs = "";
	public transferencias: Array<Transferencias> = [];
	public selectedRow: Number;
	public transferencia: Transferencias;
	public pagination: Pagination;
  public loading = false;
  
  constructor(
		public transferenciasService: TransferenciasService,
		public bsModalRef: BsModalRef,
	) {
		this.transferencias = [];
		this.transferencia = new Transferencias();
		this.pagination = new Pagination();
    }

    ngOnInit() {
      this.getVentas();
    }
  
    getTransferenciasBySearch(text){
      let qs = "";
      this.pagination.current_page = 1;
      this.getVentas(qs);
    }
  
    getVentas(qs = ""){
      this.loading = true;
      this.transferenciasService.getAll("?page="+this.pagination.current_page + "&per_page=10&embed=bodegaS,guiaremision,bodegaE?embed=sucursal,detalle?embed=producto&status=A" + this.qs + qs).subscribe(
        res => {
          this.loading = false;
          this.transferencias = res.data;
  
          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
        },
        err => {
          this.loading = false;
          this.transferencias = [];
        }
      );
    }
    
    onSelectRow(transferencia, i) {
      //Asignacion de fila
      this.selectedRow = i;
      //Asignacion de usuario
      this.transferencia = transferencia;
    }
  
    onDBLClick(usuario,i){
      this.onSelectRow(usuario,i);
      this.onSubmit();
    }
  
    onSubmit() {
      //envía de objecto usuario
      this.onSelectedRow.emit(this.transferencia);
      //Cierre de modal o componente
      this.bsModalRef.hide();
    }
  
    next(){
      this.pagination.current_page++;
      this.getVentas();
    }
  
    prev(){
      this.pagination.current_page--;
      this.getVentas();
    }
  
    first(){
      this.pagination.current_page = 1;
      this.getVentas();
    }
  
    last(){
      this.pagination.current_page = this.pagination.last_page;
      this.getVentas();
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/transferencias-list-modal/transferencias-list-modal.component.ts